var _defs, _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 271.65 205.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d8d9d8;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #d8d9d8;\n        stroke-miterlimit: 10;\n        stroke-width: 21px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m210.31,49.38c-11.73,6.68-38.09,19.62-73.97,19.76-36.57.14-63.45-13.08-75.18-19.77"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 205.12,
    y: 40.26,
    width: 20.33,
    height: 124.02
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.02,
    y: 40.26,
    width: 20.33,
    height: 124.02
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoM);
export default __webpack_public_path__ + "static/media/logo_m.f2b6e40b4677288073098438a3a1c598.svg";
export { ForwardRef as ReactComponent };